module.exports = __webpack_public_path__ + "img/android_kotlin.d1ef8eb5.svg";